import { render } from "./ArticleDescription.vue?vue&type=template&id=4a98effa&scoped=true"
import script from "./ArticleDescription.vue?vue&type=script&lang=js"
export * from "./ArticleDescription.vue?vue&type=script&lang=js"

import "./ArticleDescription.vue?vue&type=style&index=0&id=4a98effa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a98effa"]])

export default __exports__